<div ngModelGroup="formField{{ formField.id }}">
    @if (loading) {
        <sb-loader></sb-loader>
    }

    @if (!loading && categoriesList && categoriesList.length && categoriesList[0].categories?.length) {
        @if (formField.label) {
            <label (click)="selectElement?.focus()" for="form-element-{{ formField.id }}-0">
                {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
            </label>
        }

        @for (category of categoriesList; track category; let i = $index) {
            <div class="category-container form-group" [class.empty-category-selector]="!category?.categories?.length">
                @if (category && category.categories?.length) {
                    <div>
                        @if (!isMobileOrTabletDevice()) {
                            <ng-select
                                appSelectAccessibility
                                #selectElement
                                [inputAriaLabelAttribute]="formField.placeholder || 'category selector'"
                                bindLabel="name"
                                dropdownPosition="bottom"
                                name="formField{{ formField.id }}[{{ i }}]"
                                id="form-element-{{ formField.id }}-{{ i }}"
                                #select="ngModel"
                                appProhibitedCategoryValidator
                                [currentCategoryIndex]="i"
                                [categoriesList]="categoriesList"
                                appFocus
                                [appAutoFocus]="formField.isNeedToFocus"
                                [focusableSelectElement]="selectElement"
                                class="select-control"
                                [(ngModel)]="category.selectedCategory"
                                [required]="isInvalid(category, i)"
                                placeholder="{{ formField.placeholder }}{{ isRequired(i) ? ' *' : '' }}"
                                [ngClass]="{
                                    'ng-invalid': isInvalid(category, i) || select?.errors?.validateCategory?.invalid,
                                }"
                                [items]="category.categories"
                                (change)="onSelect($event, i, select)">
                            </ng-select>

                            @if (formService.isSubmitted && select?.errors?.validateCategory?.invalid) {
                                <div class="text-danger">
                                    {{
                                        'A setting prevents this category from selection. Please choose another category'
                                            | translate
                                    }}
                                </div>
                            }
                        } @else {
                            <select
                                class="form-control"
                                #select="ngModel"
                                name="formField{{ formField.id }}[{{ i }}]"
                                id="form-element-{{ formField.id }}-{{ i }}"
                                appProhibitedCategoryValidator
                                [currentCategoryIndex]="i"
                                [categoriesList]="categoriesList"
                                [title]="formField.placeholder || 'category selector'"
                                (ngModelChange)="onSelect($event, i, select)"
                                [ngClass]="{
                                    'ng-invalid': isInvalid(category, i) || select?.errors?.validateCategory?.invalid,
                                    'select-placeholder': !category.selectedCategory,
                                }"
                                [(ngModel)]="category.selectedCategory"
                                [required]="isInvalid(category, i)">
                                <option [ngValue]="null">
                                    <span>{{ formField.placeholder }}</span>
                                </option>
                                @for (option of category.categories; track option) {
                                    <option [ngValue]="option">{{ option.name }}</option>
                                }
                            </select>
                            @if (formService.isSubmitted && select?.errors?.validateCategory?.invalid) {
                                <div class="text-danger">
                                    {{
                                        'A setting prevents this category from selection. Please choose another category'
                                            | translate
                                    }}
                                </div>
                            }
                        }

                        @if (formService.isSubmitted && isInvalid(category, i)) {
                            <div class="text-danger">{{ 'Please fill this field' | translate }}</div>
                        }
                    </div>
                }
            </div>
        }
    }
</div>
